import React, {memo} from "react";
import {NodeProps} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {CompactUnit, formatCompactNumber, formatPercentage} from "@/utils/format.ts";


export const SegmentNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};

    const render_line_local = (
        l1: string,
        l2: string, datas: Record<string, Metric>,
        is_plan: boolean = false,
    ) => {
        // 拼接指标key的时候有的中间需要这个 amt，有的不需要,
        // const middle_amt = l1 == "nts" ? 'amt_' : '';
        let vol_gro_key = `${l1}_${l2}_vol_growth`
        if (l1 == "nts") {
            vol_gro_key = `${l1}_amt_${l2}_vol_growth`
        }
        if (is_plan) {
            // vol_gro_key="ims_amt_mtd_vol_growth_mip"
            vol_gro_key = "ims_mtd_vol_growth"
            if (formatPercentage(datas[vol_gro_key]?.value) == "--") {
                vol_gro_key = "ims_amt_mtd_vol_growth"
            }
        }

        return <div>
            {/*特殊类型处理 ims_vbp 变为 vbp  ims_vbp_amt_mtd*/}
            <span>{l2.toUpperCase()} {l1.replace("ims_", "").toUpperCase().replace("NONVBP", "Non-Vbp")} </span>
            <span style={get_color(`${l1}_amt_${l2}`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}`]?.value, 1)}</span>
            <span>, Gap </span>
            <span style={get_color(`${l1}_amt_${l2}_gap`, datas)}>
                {formatCompactNumber(datas[`${l1}_amt_${l2}_gap`]?.value, 1)}
            </span>
            <span>, Achi </span>
            <span style={get_color(`${l1}_amt_${l2}_achi`, datas)}>
                {formatPercentage(datas[`${l1}_amt_${l2}_achi`]?.value)}
            </span>
            <span>, <br/>Vol Gro </span>
            <span style={get_color(vol_gro_key, datas)}>
                {formatPercentage(datas[vol_gro_key]?.value)}
            </span>
            <span>&nbsp;</span>
            <span>(L3M: </span>
            <span style={get_color("ims_vol_growth_lm1", datas)}>
                {formatPercentage(datas["ims_vol_growth_lm1"]?.value, 1)}
            </span>,&nbsp;
            <span style={get_color("ims_vol_growth_lm2", datas)}>
                {formatPercentage(datas["ims_vol_growth_lm2"]?.value, 1)}
            </span>,&nbsp;
            <span style={get_color("ims_vol_growth_lm3", datas)}>
                {formatPercentage(datas["ims_vol_growth_lm3"]?.value, 1)}
            </span>
            <span>)</span>
        </div>
    }

    return <BasicCardNode node={node} showChart={true} data={data}>
        <div style={{marginLeft: '10px'}}>
            {render_line_local('ims', 'mtd', datas)}
        </div>
    </BasicCardNode>
})